import { FC, ReactNode } from "react";
import { Modal } from "../../../Modal";
import fragments50Icon from '../icons/fragments50.png';
import { Fragment } from "../../../../Fragment/Fragment";
import styles from './WelcomeBonusNotify.module.scss';
import { ThinButton } from "../../../../Buttons/ThinButton/ThinButton";
import { openPlatformLink } from "../../../../../utils/platform-links";

const PRIVACY_POLICY_URL = "https://bizneslyandiya.ru/privacy";

interface IWelcomeBonusNotifyProps {
    closeHandler: () => void;
    bonuses: ReactNode;
}

export const WelcomeBonusNotify: FC<IWelcomeBonusNotifyProps> = ({ bonuses, closeHandler }) => {
    const getContext = () => {
        return (
            <>
                <p>
                    <span>Вы выиграли первый</span>
                    <span className={styles.fragment}><Fragment /></span>
                    <span>фрагмент сертификата.</span>
                </p>
                <p>
                    Собрав 50 таких фрагментов вы получите сертификат Wildberries на 500 ₽.
                </p>

                <p><b>А это ваш стартовый набор</b></p>
                <p>{ bonuses }</p>
            </>
        );
    }
    
    const footer = (
        <p className={styles.footerText}>
            {'Нажимая "Начать игру", вы подтверждаете, что ознакомлены с '}
            <a
                className={styles.footerLink}
                href={PRIVACY_POLICY_URL}
                onClick={(e) => {
                    e.preventDefault();
                    openPlatformLink(PRIVACY_POLICY_URL);
                }}
            >
                политикой обработки персональных данных
            </a>
            .
        </p>
    );

    return (
        <Modal
            name='WelcomeBonusNotify'
            title='Поздравляем!'
            message={ getContext() }
            icon={fragments50Icon}
            button={ <ThinButton caption='Начать игру' handler={ () => closeHandler() } /> }
            footer={footer}
        />
    );
}